.integrations-rail {
  --carousel-rail-gap: var(--size4);
  --carousel-rail-slide-size: calc((100cqw - var(--carousel-rail-gap)) / 2);
}

.integrations-rail .carousel-rail__footer {
  justify-content: space-between;
  order: 0;
}

.integrations-rail .carousel-rail__footer-controls {
  @media screen and (width >= 64rem) {
    display: none;
  }
}

.integrations-rail .carousel-rail__header {
  @media screen and (width >= 64rem) {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
}

.integrations-rail .carousel-rail__viewport-controls {
  @media screen and (width >= 64rem) {
    display: flex;
  }
}

.integrations-rail .carousel-rail__view-all {
  display: inline;
}

.integrations-rail .carousel-rail__viewport {
  margin-bottom: calc(var(--size6) * -1);
  padding-bottom: var(--size6);
}

.integration-rail-card {
  align-items: center;
  background: var(--color-pure-white-next);
  border: 1px solid var(--color-border-light-next);
  border-radius: 6px;
  color: var(--color-brand-dark-next);
  display: flex;
  flex-direction: column;
  gap: var(--size7);
  height: 194px;
  justify-content: center;
  padding: var(--size6);
  text-align: center;
  text-decoration: none;
  transition:
    box-shadow 180ms ease,
    transform 220ms cubic-bezier(0.16, 1, 0.3, 1);
}

@media screen and (width >= 43.75rem) {
  .integrations-rail {
    --carousel-rail-slide-size: calc((100cqw - var(--carousel-rail-gap)) / 2);
  }
}

.integration-rail-card:focus-visible {
  outline: 2px solid var(--color-accent-blue-next);
  outline-offset: 3px;
}

.integration-rail-card:hover,
.integration-rail-card:focus-visible {
  box-shadow: 0 10px 24px rgb(92 0 46 / 8%);
  transform: translateY(-2px);
}

.integration-rail-card__icon {
  align-items: center;
  display: flex;
  height: 82px;
  justify-content: center;
  transition: transform 220ms cubic-bezier(0.16, 1, 0.3, 1);
  width: 82px;
}

.integration-rail-card:hover .integration-rail-card__icon,
.integration-rail-card:focus-visible .integration-rail-card__icon {
  transform: scale(1.025);
}

.integration-rail-card__icon svg {
  height: 100%;
  max-height: 82px;
  max-width: 82px;
  width: 100%;
}

.integration-rail-card__label {
  color: inherit;
}

@media screen and (width >= 64rem) {
  .integrations-rail {
    --carousel-rail-slide-size: calc(
      (100cqw - (var(--carousel-rail-gap) * 4)) / 5
    );
  }

  .integrations-rail .carousel-rail__view-all {
    margin-top: var(--size6);
  }
}
